const popErr = document.getElementById('errorPopup');
console.log("[popup] popErr", popErr);
const popSuccess = document.getElementById('successPopup');
console.log("[popup] popSuccess", popSuccess);
const popupBtn = document.getElementById('popup_btn');
console.log("[popup] popupBtn", popupBtn);

const DELAY_ERROR = 4000;
const DELAY_SUCCESS = 2000;

/**
 * Show a popup message.
 * @param {HTMLElement} el - The popup element.
 * @param {string} text - The message text.
 * @param {number} timeout - The duration (in milliseconds) to show the popup (0 for no auto-hide).
 * @param {string} btnText - Optional text for the button.
 * @param {function} btnCallback - Optional callback function for the button.
 */
function _showPopup(el, text, timeout, btnText = '', btnCallback = null) {
    const p = el.querySelector('p');
    console.log("[popup::showPopup] p", p);
    if (p) p.textContent = text || '';
    el.classList.add('show');
    el.classList.remove('hidden');
    if (btnText) {
        popupBtn.textContent = btnText;
        popupBtn.classList.remove('hidden');
        popupBtn.classList.add('show');
        console.log("[popup::showPopup] btnText", btnText);
        popupBtn.onclick = () => {
            btnCallback && btnCallback();
            el.classList.remove('show');
            popupBtn.classList.add('hidden');
        };
    } else {
        popupBtn.classList.add('hidden');
        popupBtn.onclick = null;
    }
    if (timeout > 0) {
        setTimeout(() => el.classList.remove('show'), timeout);
    }
}

/**
 * Show an error popup message.
 * @param {string} text - The error message text.
 * @param {number} timeout - The duration (in milliseconds) to show the popup (0 for no auto-hide).
 * @param {string} btnText - Optional text for the button.
 * @param {function} btnCallback - Optional callback function for the button.
 */
function showErrorPopup(text, timeout = DELAY_ERROR, btnText = '', btnCallback=null) {
    console.log("[popup::showErrorPopup] text", text, btnText, btnCallback);
    _showPopup(popErr, text, timeout, btnText, btnCallback);
}

/** x
 * Show a success popup message.
 * @param {string} text - The success message text.
 * @param {number} timeout - The duration (in milliseconds) to show the popup (0 for no auto-hide).
 * @param {string} btnText - Optional text for the button.
 * @param {function} btnCallback - Optional callback function for the button.
 */
function showSuccessPopup(text, timeout = DELAY_SUCCESS, btnText = '', btnCallback=null) {
    console.log("[popup::showSuccessPopup] text", text, btnText, btnCallback);
    _showPopup(popSuccess, text, timeout, btnText, btnCallback);
}

